import React from 'react';
import { Platform, ScrollView } from 'react-native';
import styled from 'styled-components/native';

import Spacer from '../../components/Spacer';
import { H4, P } from '../../components/Typography';

const StyledView = styled.View`
  flex: 1;
  background-color: white;
  align-items: center;
  justify-content: center;
  padding: 20px 10px 20px 10px;
`;

const HealthKitGoogleFitSampleScreen: React.FC = () => {
  return (
    <ScrollView>
      <StyledView>
        <H4 center padding={5}>{`${
          Platform.OS === 'android' ? 'Google Fit' : 'Apple HealthKit'
        } Integration`}</H4>
        <Spacer size={4} />
        <P>Not available on Web</P>
      </StyledView>
    </ScrollView>
  );
};

export default HealthKitGoogleFitSampleScreen;
